import { differenceInCalendarMonths } from "date-fns";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const formatDueIn = (
	targetDate: string | null | undefined,
	t: TranslateFunction,
): string => {
	if (!targetDate) return "";
	const months = Math.max(
		0,
		differenceInCalendarMonths(new Date(targetDate), new Date()),
	);
	if (months >= 12) {
		return t(Resources.Goals.List.DueIn.Years, {
			count: Math.floor(months / 12),
		});
	}
	return t(Resources.Goals.List.DueIn.Months, { count: months });
};
